export default __webpack_public_path__ + "static/media/cloudinary.df0c0e93.svg";